import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableDataSet } from '@/models/tableDataset/TableDataSet';

import { LoggerService } from '@/utils';
import { ConfigurationSection } from '@/models/configuration/Section';
import { TableDataSetField } from '@/models/tableDataset/TableDataSetField';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { DataSetStore } from '@/store/store.dataSet';
import { DataSetField } from '@/models/dataset/DataSetField';
import { DataSetService } from '@/services/index';
import { Helpers } from '@/helpers/Helpers';
import { ApiIdentifers } from '@/config/index';

import SettingsReportValues from '@/components/settingsreport/settingsreportvalues/SettingsReportValues.vue';

@Component({
    components: {
        SettingsReportValues,
    },
})
export default class SettingsReportComponent extends Vue {
    @PropSync('data', { type: Object }) public syncedData!: TableDataSet;
    @PropSync('empty', { type: Boolean }) public syncedEmpty!: boolean;

    public dataSet?: TableDataSet;
    public showLoader: boolean = true;
    public createdDate: string = '';
    public createdTime: string = '';
    public createdBy: string = '';
    public editedDate: string = '';
    public editedTime: string = '';
    public editedBy: string = '';
    public showModifed: boolean = false;
    public myMillExtractedDate: string = '';
    public showMyMill: boolean = false;

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.loadData(this.syncedData);
    }

    @Watch('syncedData', { deep: true })
    public onSyncedDataSetIdChanged(newValue: TableDataSet) {
        if (newValue !== undefined) {
            this.loadData(newValue);
        }
    }

    public loadData(inData: TableDataSet) {
        this.showLoader = true;

        if (this.syncedData !== undefined) {
            this.dataSet = new TableDataSet(inData);
            this.createdBy = '';
            let dateShow = new Date().toISOString();

            // remove machine order section, not needed for report
            const ind = this.dataSet.sections.findIndex((sec) => sec.identifier === ApiIdentifers.machineOrder);
            if (ind >= 0) {
                this.dataSet.sections.splice(ind, 1);
            }

            if (this.syncedEmpty !== true) {
                dateShow = this.dataSet.created.date;
                this.createdBy = this.dataSet.created.userName;
                for (let sectionIndex = this.dataSet.sections.length - 1; sectionIndex >= 0; sectionIndex--) {
                    const section = this.dataSet.sections[sectionIndex];
                    if (section.fields != null) {
                        this.removeEmtpyFields(section.fields);
                    }
                    // check if there are only unit fields left
                    const unitsOnly = this.checkUnitsOnly(section.fields);
                    // remove if no fields or only unit fields left
                    if (section.fields == null || section.fields.length === 0 || unitsOnly === true) {
                        this.dataSet.sections.splice(sectionIndex, 1);
                    }
                }
            }
            this.createdDate = Helpers.getFormattedDateString(this.dataSet.created.date);
            this.createdTime = Helpers.getFormattedTimeString(this.dataSet.created.date);
            if (this.dataSet.lastModified) {
                this.showModifed = true;
                this.editedBy = this.dataSet.lastModified.userName;
                this.editedDate = Helpers.getFormattedDateString(this.dataSet.lastModified.date);
                this.editedTime = Helpers.getFormattedTimeString(this.dataSet.lastModified.date);
            }
            if (this.dataSet.myMillImport) {
                this.showMyMill = true;
                this.myMillExtractedDate = Helpers.getExportDateTimeString(this.dataSet.myMillImport.extractionDate);
            }
        }
        LoggerService.LogDebug(`loadData`, this.dataSet);
        this.showLoader = false;
    }

    private removeEmtpyFields(inFields: TableDataSetField[]) {
        for (let fieldIndex = inFields.length - 1; fieldIndex >= 0; fieldIndex--) {
            const field = inFields[fieldIndex];
            if (field.fields != null && field.fields.length > 0) {
                // if has sub fieldsx, iterrate recursivly
                this.removeEmtpyFields(field.fields);
                // check if there are only unit fields left
                const unitsOnly = this.checkUnitsOnly(field.fields);
                // remove if no fields or only unit fields left
                if (field.fields.length === 0 || unitsOnly === true) {
                    inFields.splice(fieldIndex, 1);
                }
            } else {
                // remove fields without a value, except unit fields
                if (field.type !== FieldTypeEnum.UNIT && field.valueBool == null && field.valueNumber == null && field.valueString == null) {
                    inFields.splice(fieldIndex, 1);
                }
            }
        }
    }

    private checkUnitsOnly(inFields: TableDataSetField[]): boolean {
        let unitsOnly = true;
        if (inFields.length > 0) {
            for (const iterator of inFields) {
                if (iterator.type !== FieldTypeEnum.UNIT) {
                    unitsOnly = false;
                    break;
                }
            }
        }
        return unitsOnly;
    }

    private sortSectionsFields(sectionFields: DataSetField[]) {
        sectionFields.forEach((sectionField: DataSetField) => {
            if (sectionField.fields != null) {
                this.sortSectionsFields(sectionField.fields);
            }
        });

        sectionFields.sort(this.sortFields);
    }

    private sortFields(lhs: DataSetField, rhs: DataSetField): number {
        if (lhs.fields != null && rhs.fields != null) {
            return 0;
        } else if (lhs.fields == null && rhs.fields != null) {
            return -1;
        } else if (rhs.fields == null && lhs.fields != null) {
            return 1;
        }
        return 1;
    }
}
